// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"38a50e60","356":"36a729fd","426":"6fb5e384","579":"9b0eb360","583":"2209f830","969":"c14a4795"}[chunkId] + ".chunk.js";
};